import React from 'react';
import { ResourceManager } from './components/ResourceManager';

const HeroSlidesModule = () => (
  <ResourceManager
    table="hero_slides"
    title="Hero Slides"
    description="Control the cinematic hero experience on the landing page."
    columns={[
      { label: 'Title', accessor: 'title' },
      { label: 'Order', accessor: 'order' },
      {
        label: 'Active',
        accessor: 'is_active',
        render: (value) => (value ? 'Yes' : 'No'),
      },
    ]}
    formFields={[
      { name: 'title', label: 'Slide Title', placeholder: 'Daily Payments, Your Home' },
      { name: 'subtitle', label: 'Subtitle', placeholder: 'Own forever' },
      { name: 'background_image', label: 'Background Image URL', placeholder: 'https://...' },
      { name: 'interior_image', label: 'Interior Image URL', placeholder: 'https://...' },
      { name: 'video_url', label: 'Video URL (optional)', placeholder: 'https://...' },
      { name: 'order', label: 'Display Order', type: 'number', placeholder: '1' },
      { name: 'is_active', label: 'Active', type: 'checkbox' },
    ]}
    defaultValues={{
      title: '',
      subtitle: '',
      background_image: '',
      interior_image: '',
      video_url: '',
      order: 1,
      is_active: true,
    }}
    transformBeforeSave={(payload) => ({
      ...payload,
      order: Number(payload.order) || 0,
    })}
  />
);

export default HeroSlidesModule;
